import { createColumnHelper } from '@tanstack/react-table';
import { Trash2 } from 'lucide-react';

import { Button } from '@@/buttons';
import { Badge } from '@@/Badge';

import { SilencedAlertRow } from './types';

export const columnHelper = createColumnHelper<SilencedAlertRow>();

export function createColumns(onDelete: (silenceId: string) => void) {
  return [
    columnHelper.accessor('environmentName', {
      header: 'Environment',
    }),
    columnHelper.accessor('environmentGroupName', {
      header: 'Environment Group',
    }),
    columnHelper.accessor('alertRule', {
      header: 'Alert Rule',
    }),
    columnHelper.accessor('status', {
      header: 'Status',
      cell: ({ getValue }) => {
        const status = getValue();
        let badgeType: 'success' | 'warn' | 'muted' | 'danger' = 'muted';

        if (status === 'active') {
          badgeType = 'success';
        } else if (status === 'pending') {
          badgeType = 'warn';
        } else if (status === 'expired') {
          badgeType = 'muted';
        } else {
          badgeType = 'danger';
        }

        return <Badge type={badgeType}>{status}</Badge>;
      },
    }),
    columnHelper.display({
      id: 'actions',
      header: 'Actions',
      cell: ({ row }) => {
        const silence = row.original;
        return (
          <Button
            color="dangerlight"
            size="small"
            onClick={() => onDelete(silence.id)}
            disabled={!silence.canDelete}
            title={
              silence.canDelete
                ? 'Delete silence'
                : 'Cannot delete expired/revoked silence'
            }
            data-cy={`delete-silence-${silence.id}`}
          >
            <Trash2 className="h-4 w-4" />
          </Button>
        );
      },
      meta: { disableGrouping: true },
    }),
    columnHelper.accessor('comment', {
      header: 'Comment',
      meta: { disableGrouping: true },
    }),
    columnHelper.accessor('createdBy', {
      header: 'Created By',
    }),
    columnHelper.accessor('startsAt', {
      header: 'Starts At',
      meta: { disableGrouping: true },
    }),
    columnHelper.accessor('endsAt', {
      header: 'Ends At',
      meta: { disableGrouping: true },
    }),
  ];
}
